import React from 'react';
import Calendar from '../assets/images/Calendar.svg';

export default () => {
  return <img src={Calendar} alt="" />;
};
